import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

const messages = {
    zh,
    en
}

// 默认语言
const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'zh', // set locale
    messages, // set locale messages
    fallbackLocale: 'zh'
})

export default i18n
